export default __webpack_public_path__ + "static/media/10_1.1130f1ed.jpg";